// import Vue from 'vue'

const appInput = {
  namespaced: true,
  state: {
    open: false,
    boundData: false
  },
  mutations: {
    openInput(state) {
      state.open = true
    },
    closeInput(state) {
      state.open = false
    },
    bindInput(state, boundData) {
      if (state.boundData) {
        if (state.boundData.value == '' && state.boundData.previous != '') {
          state.boundData.value = state.boundData.previous
        }
        state.boundData.isActive = false
        state.boundData = false
      }
      boundData.previous = boundData.value
      state.boundData = boundData
      boundData.isActive = true
    },
    commitInput(state) {
      if (state.boundData) {
        let value = state.boundData.value
        let decimalIndex = value.indexOf('.')

        if (decimalIndex > -1) {
          // Remove trailing zeros and decimals
          for (let i = value.length - 1; i > 0; i--) {
            let character = value[i]
            if ( character == "0") {
              value = value.slice(0, -1)
            } else if (character == ".") {
              value = value.slice(0, -1)
              break
            } else {
              break
            }
          }
          if (state.boundData.decimalLimit == 2 && value.length - value.indexOf('.') == 2) {
            value += "0"
          } 
        }
        state.boundData.value = value
        if ('updateDefault' in state.boundData && state.boundData.updateDefaults) {
          state.boundData.updateDefault()
        }
        state.boundData.isActive = false
        state.boundData = false
      }
    },
    cancelInput(state) {
      if (state.boundData) {
        state.boundData.value = state.boundData.previous
        state.boundData.isActive = false
        state.boundData = false
      }
    },
  },
  actions: {
    openInput(context) {
      if (context.rootState.isMobile) {
        context.commit('openInput')
      }
    },
    bindInput(context, boundData) {
      context.commit('bindInput', boundData)
      context.dispatch('openInput')
    },
    commitInput(context) {
      context.commit('commitInput')
      context.commit('closeInput')
    },
    cancelInput(context) {
      context.commit('cancelInput')
      context.commit('closeInput')
    }
  }
}

export default appInput